import { render } from "./AdminOrderLogList.vue?vue&type=template&id=1ccbd928&scoped=true&ts=true&lang=true"
import script from "./AdminOrderLogList.vue?vue&type=script&lang=ts"
export * from "./AdminOrderLogList.vue?vue&type=script&lang=ts"

import "./AdminOrderLogList.vue?vue&type=style&index=0&id=1ccbd928&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccbd928"]])

export default __exports__